import React, { useState } from "react";
import { LayoutDashboard, Package, Tags, Truck, ShoppingBag, BarChart3, Settings2, Palette } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import {
  ShopOverviewPanel, ShopProductsPanel, ShopCategoriesPanel, ShopBrandPhotosPanel, ShopColorsPanel, ShopSuppliersPanel,
  ShopOrdersPanel, SupplierOrdersPanel, ShopStatsPanel, ShopSettingsPanel,
} from "@/components/admin/ShopPanels";

// Full boutique management for the dev console (internal tabs)
export const DevShop = () => {
  const { t } = useLang();
  const s = t.ashop;
  const [tab, setTab] = useState("overview");

  const TABS = [
    { id: "overview", label: s.tab_overview, icon: LayoutDashboard },
    { id: "products", label: s.tab_products, icon: Package },
    { id: "categories", label: s.tab_categories, icon: Tags },
    { id: "colors", label: s.tab_colors, icon: Palette },
    { id: "suppliers", label: s.tab_suppliers, icon: Truck },
    { id: "orders", label: s.tab_orders, icon: ShoppingBag },
    { id: "stats", label: s.tab_stats, icon: BarChart3 },
    { id: "settings", label: s.tab_settings, icon: Settings2 },
  ];

  return (
    <div data-testid="dev-shop">
      <div className="flex gap-2 overflow-x-auto pb-1 mb-5" data-testid="dev-shop-tabs">
        {TABS.map((tb) => (
          <button
            key={tb.id}
            onClick={() => setTab(tb.id)}
            className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold whitespace-nowrap transition-colors no-a11y-underline ${
              tab === tb.id ? "bg-brand text-brand-cream" : "bg-white text-brand-ink/70 border border-brand/10 hover:bg-brand-soft/50"
            }`}
            data-testid={`dev-shop-tab-${tb.id}`}
          >
            <tb.icon className="h-4 w-4" /> {tb.label}
          </button>
        ))}
      </div>
      {tab === "overview" && <ShopOverviewPanel />}
      {tab === "products" && <ShopProductsPanel devMode />}
      {tab === "categories" && (
        <div className="space-y-10">
          <ShopCategoriesPanel />
          <ShopBrandPhotosPanel />
        </div>
      )}
      {tab === "colors" && <ShopColorsPanel />}
      {tab === "suppliers" && (
        <div className="space-y-8">
          <ShopSuppliersPanel />
          <div>
            <h3 className="font-heading text-2xl font-bold text-brand-ink mb-3">{s.supplier_orders_title}</h3>
            <SupplierOrdersPanel />
          </div>
        </div>
      )}
      {tab === "orders" && <ShopOrdersPanel />}
      {tab === "stats" && <ShopStatsPanel />}
      {tab === "settings" && <ShopSettingsPanel />}
    </div>
  );
};

export default DevShop;
